import Vue from "vue";
import VueMeta from "vue-meta";

Vue.use(VueMeta);
import SlideUpDown from "vue-slide-up-down";
import PortalVue from "portal-vue";
import _ from "lodash";
import cf from "@/helpers/conf";
import fn from "@/helpers/func"; 
import VueAwesomeSwiper from "vue-awesome-swiper";
import VueRecaptcha from "vue-recaptcha";

Vue.prototype.$map_key = "";
Vue.use(VueAwesomeSwiper);
Vue.component("VueRecaptcha", VueRecaptcha);
Vue.use(require("vue-moment"), {
  moment
});
var moment = require("moment");

Vue.prototype.$fn = fn;
Vue.prototype.$cf = cf;
Vue.component("slide-up-down", SlideUpDown);
Vue.use(PortalVue);
Vue.use(_);
Vue.prototype._ = _;

import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps);